import { GET_CONFIG_DETAILS } from "./type"; // Fixed import

const initialState = {
  details: [],
};

const configDetailsreducer = (state = initialState, action) => {
  console.log("actions", action.payload);
  switch (action.type) {
    case GET_CONFIG_DETAILS:
      return {
        ...state,
        details: action.payload,
      };

    default:
      return state;
  }
};

export default configDetailsreducer;
